export interface Manhwa {
  id: string;
  title: string;
  author: string;
  category: string;
  categorySlug: string;
  coverImage: string;
  description: string;
  rating: number;
  totalChapters: number;
  status: '连载中' | '已完结';
  updateDate: string;
  views: number;
  tags: string[];
  chapters: Chapter[];
}

export interface Chapter {
  id: string;
  title: string;
  number: number;
  updateDate: string;
  views: number;
}

export const manhwas: Manhwa[] = [
  {
    id: 'duke-contract-fiancee',
    title: '公爵的契约未婚妻',
    author: 'Milcha',
    category: '恋爱',
    categorySlug: 'romance',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20of%20a%20beautiful%20noblewoman%20in%20elegant%20Victorian%20dress%2C%20soft%20warm%20lighting%2C%20romantic%20atmosphere%2C%20detailed%20character%20design%2C%20clean%20background%20with%20warm%20coral%20and%20gold%20tones%2C%20anime%20art%20style%2C%20soft%20shadows&width=600&height=800&seq=manhwa-cover-01&orientation=portrait',
    description: '平凡的女大学生意外穿越到小说世界，成为了公爵的契约未婚妻。在这个充满阴谋与权力斗争的世界里，她必须凭借自己的智慧与勇气，在复杂的贵族社会中生存下去。然而，原本冷酷无情的公爵大人，却在她面前展现出不一样的一面……一段跨越次元的浪漫爱情故事就此展开。',
    rating: 9.5,
    totalChapters: 156,
    status: '连载中',
    updateDate: '2026-08-03',
    views: 12850000,
    tags: ['穿越', '贵族', '恋爱', '逆袭'],
    chapters: [
      { id: 'ch-156', title: '第156话 黎明的约定', number: 156, updateDate: '2026-08-03', views: 285000 },
      { id: 'ch-155', title: '第155话 暗流涌动', number: 155, updateDate: '2026-07-27', views: 312000 },
      { id: 'ch-154', title: '第154话 花园密会', number: 154, updateDate: '2026-07-20', views: 298000 },
      { id: 'ch-153', title: '第153话 危机四伏', number: 153, updateDate: '2026-07-13', views: 305000 },
    ],
  },
  {
    id: 'solo-leveling',
    title: '我独自升级',
    author: 'Chugong',
    category: '动作',
    categorySlug: 'action',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20style%20illustration%20of%20a%20powerful%20male%20hunter%20with%20dark%20armor%20and%20glowing%20eyes%2C%20dramatic%20lighting%2C%20action%20pose%2C%20dark%20fantasy%20atmosphere%2C%20clean%20minimal%20background%20with%20shadow%20effects%2C%20intense%20expression&width=600&height=800&seq=manhwa-cover-02&orientation=portrait',
    description: '在这个世界，连接异次元的"门"突然出现，觉醒者们挺身而出对抗怪物。被称为"人类最弱兵器"的成振宇，在一次几乎全军覆没的地下城探险中，获得了神秘的游戏系统——"玩家"。从此，只有他一个人能够"升级"。在不断变强的过程中，他逐渐揭开了"门"背后的惊天秘密……',
    rating: 9.8,
    totalChapters: 179,
    status: '已完结',
    updateDate: '2025-12-20',
    views: 35680000,
    tags: ['战斗', '升级', '系统', '热血'],
    chapters: [
      { id: 'ch-179', title: '第179话 终章·新的开始', number: 179, updateDate: '2025-12-20', views: 1250000 },
      { id: 'ch-178', title: '第178话 最终决战', number: 178, updateDate: '2025-12-13', views: 1180000 },
      { id: 'ch-177', title: '第177话 觉醒之力', number: 177, updateDate: '2025-12-06', views: 1050000 },
    ],
  },
  {
    id: 'omniscient-reader',
    title: '全知读者视角',
    author: 'Sing Shong',
    category: '奇幻',
    categorySlug: 'fantasy',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20of%20a%20young%20man%20in%20white%20coat%20reading%20a%20book%20with%20mystical%20energy%2C%20fantasy%20sci-fi%20elements%2C%20warm%20dramatic%20lighting%2C%20clean%20composition%2C%20detailed%20character%20features&width=600&height=800&seq=manhwa-cover-03&orientation=portrait',
    description: '金独子是一个普通的上班族，十年来他唯一阅读的网络小说《在灭亡的世界中存活的三种方法》即将完结。然而就在最后一章更新的那天，小说中的世界竟然变成了现实。凭借十年来积累的"全知"情报，金独子要在末日般的场景中挣扎求生，改写这个世界的结局。',
    rating: 9.7,
    totalChapters: 210,
    status: '连载中',
    updateDate: '2026-08-02',
    views: 28950000,
    tags: ['末世', '系统', '智力', '冒险'],
    chapters: [
      { id: 'ch-210', title: '第210话 神话的终结', number: 210, updateDate: '2026-08-02', views: 568000 },
      { id: 'ch-209', title: '第209话 最后的故事', number: 209, updateDate: '2026-07-26', views: 542000 },
      { id: 'ch-208', title: '第208话 众神黄昏', number: 208, updateDate: '2026-07-19', views: 530000 },
      { id: 'ch-207', title: '第207话 绝境反击', number: 207, updateDate: '2026-07-12', views: 515000 },
    ],
  },
  {
    id: 'who-made-me-princess',
    title: '某天成为公主',
    author: 'Plutus',
    category: '恋爱',
    categorySlug: 'romance',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20of%20a%20cute%20princess%20in%20pink%20elegant%20dress%20with%20golden%20hair%2C%20fairy%20tale%20atmosphere%2C%20sparkling%20effects%2C%20warm%20and%20dreamy%20lighting%2C%20palace%20background%2C%20soft%20coral%20color%20palette&width=600&height=800&seq=manhwa-cover-04&orientation=portrait',
    description: '普通女大学生一夜之间穿越成为小说中的公主——阿塔纳西娅。但问题是，她穿成的是一位注定要被亲生父亲杀死的悲剧公主！为了改变悲惨命运，她必须想方设法讨好那位冷漠无情的皇帝父亲。然而在这场父女之间的温情攻防战中，她渐渐发现了隐藏在帝国深处的秘密……',
    rating: 9.6,
    totalChapters: 125,
    status: '已完结',
    updateDate: '2025-10-15',
    views: 20120000,
    tags: ['穿越', '公主', '亲情', '逆袭'],
    chapters: [
      { id: 'ch-125', title: '第125话 永远的公主', number: 125, updateDate: '2025-10-15', views: 890000 },
      { id: 'ch-124', title: '第124话 帝国的荣光', number: 124, updateDate: '2025-10-08', views: 785000 },
      { id: 'ch-123', title: '第123话 父亲的心', number: 123, updateDate: '2025-10-01', views: 810000 },
    ],
  },
  {
    id: 'villainess-male-lead',
    title: '反派小姐的男主大人',
    author: 'Yun Yeo-wool',
    category: '恋爱',
    categorySlug: 'romance',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20of%20a%20confident%20noblewoman%20with%20dark%20hair%20in%20red%20dress%2C%20elegant%20and%20dramatic%20pose%2C%20romantic%20intense%20atmosphere%2C%20warm%20lighting%2C%20clean%20lifestyle%20background&width=600&height=800&seq=manhwa-cover-05&orientation=portrait',
    description: '穿成小说中的反派大小姐后，赛琳娜决定远离原著剧情，安安稳稳过日子。可谁能想到，本该和女主在一起的男主大人，却偏偏对她穷追不舍！一边要应付男主的猛烈攻势，一边还要提防原著剧情的强制修正——这场甜蜜又危险的恋爱游戏，到底谁能笑到最后？',
    rating: 9.3,
    totalChapters: 98,
    status: '连载中',
    updateDate: '2026-08-01',
    views: 8650000,
    tags: ['穿越', '反派', '恋爱', '搞笑'],
    chapters: [
      { id: 'ch-98', title: '第98话 心跳加速', number: 98, updateDate: '2026-08-01', views: 198000 },
      { id: 'ch-97', title: '第97话 意外之吻', number: 97, updateDate: '2026-07-25', views: 215000 },
      { id: 'ch-96', title: '第96话 暴风雨前夜', number: 96, updateDate: '2026-07-18', views: 205000 },
    ],
  },
  {
    id: 'sweet-lies',
    title: '甜蜜的谎言',
    author: 'Han Ji-won',
    category: '剧情',
    categorySlug: 'drama',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20of%20a%20couple%20in%20warm%20embrace%2C%20emotional%20atmosphere%2C%20dramatic%20romantic%20scene%2C%20soft%20tearful%20expression%2C%20warm%20coral%20and%20gold%20lighting%2C%20clean%20minimal%20background&width=600&height=800&seq=manhwa-cover-06&orientation=portrait',
    description: '为了治好妹妹的绝症，李素恩不得不冒充失踪的财阀千金进入豪门。每一天都在谎言中度过，每一天都怕被揭穿。然而当她渐渐融入这个家庭，与冷酷的财阀继承人也产生了微妙的情感时，真正的千金小姐却突然归来。所有的谎言，即将在残酷的真相面前崩塌……',
    rating: 9.4,
    totalChapters: 87,
    status: '连载中',
    updateDate: '2026-08-04',
    views: 9870000,
    tags: ['财阀', '替身', '虐恋', '治愈'],
    chapters: [
      { id: 'ch-87', title: '第87话 真相大白', number: 87, updateDate: '2026-08-04', views: 356000 },
      { id: 'ch-86', title: '第86话 最后的谎言', number: 86, updateDate: '2026-07-28', views: 342000 },
      { id: 'ch-85', title: '第85话 裂缝', number: 85, updateDate: '2026-07-21', views: 328000 },
      { id: 'ch-84', title: '第84话 怀疑的种子', number: 84, updateDate: '2026-07-14', views: 315000 },
    ],
  },
  {
    id: 'god-level-lucky-star',
    title: '神级幸运星',
    author: 'Park Tae-joon',
    category: '搞笑',
    categorySlug: 'comedy',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20of%20a%20cheerful%20young%20man%20with%20bright%20smile%2C%20comedy%20expression%2C%20colorful%20and%20playful%20atmosphere%2C%20warm%20golden%20lighting%2C%20clean%20simple%20background%2C%20cartoonish%20vibe&width=600&height=800&seq=manhwa-cover-07&orientation=portrait',
    description: '从小到大运气差到极点的林小星，在某天意外获得了"幸运之神"的系统加持。从此他的人生彻底反转——走路捡钱、考试满分、女神倒追！但天下没有免费的午餐，每次使用幸运值的背后，都有着意想不到的代价。当幸运值即将耗尽的那一刻，他才明白什么才是真正的"幸运"……',
    rating: 9.1,
    totalChapters: 142,
    status: '连载中',
    updateDate: '2026-08-03',
    views: 11250000,
    tags: ['搞笑', '系统', '逆袭', '校园'],
    chapters: [
      { id: 'ch-142', title: '第142话 幸运之神的试炼', number: 142, updateDate: '2026-08-03', views: 245000 },
      { id: 'ch-141', title: '第141话 意想不到的结局', number: 141, updateDate: '2026-07-27', views: 258000 },
      { id: 'ch-140', title: '第140话 命运的赌局', number: 140, updateDate: '2026-07-20', views: 262000 },
    ],
  },
  {
    id: 'rebirth-urban-cultivator',
    title: '重生之都市修仙',
    author: 'Xiao Qian',
    category: '动作',
    categorySlug: 'action',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20of%20a%20cool%20male%20cultivator%20in%20modern%20city%20setting%2C%20martial%20arts%20vibe%2C%20dramatic%20wind%20effects%2C%20warm%20sunset%20lighting%2C%20urban%20background%2C%20intense%20gaze&width=600&height=800&seq=manhwa-cover-08&orientation=portrait',
    description: '修仙界第一高手陈凡，渡劫失败后重生回到地球的少年时代。前世所有的遗憾、所有的屈辱，这一世他要用实力一一改写！在繁华的现代都市中，他一边低调修炼，一边碾压各路豪门高手。但当修仙界的宿敌也追踪而至，他才发现——这场重生，远比他想象中更加波澜壮阔。',
    rating: 9.2,
    totalChapters: 188,
    status: '连载中',
    updateDate: '2026-08-02',
    views: 14560000,
    tags: ['重生', '修仙', '都市', '爽文'],
    chapters: [
      { id: 'ch-188', title: '第188话 天劫降临', number: 188, updateDate: '2026-08-02', views: 425000 },
      { id: 'ch-187', title: '第187话 仙界来客', number: 187, updateDate: '2026-07-26', views: 410000 },
      { id: 'ch-186', title: '第186话 金丹大成', number: 186, updateDate: '2026-07-19', views: 398000 },
    ],
  },
  {
    id: 'abyss-flower',
    title: '深渊之花',
    author: 'Lee Hye-min',
    category: '悬疑',
    categorySlug: 'suspense',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20of%20a%20mysterious%20woman%20in%20dark%20elegant%20dress%2C%20thriller%20atmosphere%2C%20dramatic%20lighting%20with%20shadows%2C%20mysterious%20and%20suspenseful%20mood%2C%20clean%20dark%20background%20with%20subtle%20red%20accents&width=600&height=800&seq=manhwa-cover-09&orientation=portrait',
    description: '首尔江南区一栋豪华公寓内，发生了连环失踪案。女刑警韩智雅在调查中发现，所有失踪者都曾光顾过同一家神秘的地下酒吧——"深渊"。随着调查深入，一个庞大的暗网犯罪组织浮出水面。而更令她震惊的是，这个组织的幕后主使，竟是十年前被认为已经死亡的那个人……',
    rating: 9.6,
    totalChapters: 73,
    status: '连载中',
    updateDate: '2026-08-01',
    views: 7650000,
    tags: ['悬疑', '犯罪', '推理', '暗黑'],
    chapters: [
      { id: 'ch-73', title: '第73话 深渊之底', number: 73, updateDate: '2026-08-01', views: 195000 },
      { id: 'ch-72', title: '第72话 最后的拼图', number: 72, updateDate: '2026-07-25', views: 210000 },
      { id: 'ch-71', title: '第71话 暗网深处', number: 71, updateDate: '2026-07-18', views: 205000 },
      { id: 'ch-70', title: '第70话 第三名失踪者', number: 70, updateDate: '2026-07-11', views: 198000 },
    ],
  },
  {
    id: 'moonlight-sculptor',
    title: '月光雕刻师',
    author: 'Nam Hee-sung',
    category: '奇幻',
    categorySlug: 'fantasy',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20of%20a%20fantasy%20character%20with%20magical%20sculpting%20tools%20surrounded%20by%20moonlight%2C%20ethereal%20atmosphere%2C%20mystical%20glow%2C%20warm%20silver%20and%20gold%20tones%2C%20clean%20fantasy%20background&width=600&height=800&seq=manhwa-cover-10&orientation=portrait',
    description: '为了偿还巨额债务，李贤秀进入虚拟现实游戏《皇家之路》。他选择了最不被看好的隐藏职业——月光雕刻师。在这个无比真实的游戏世界中，他用手中的雕刻刀创造奇迹，从默默无闻的菜鸟一步步成长为传奇。然而，当游戏与现实之间的界限开始模糊，他才发现这场冒险的真正意义……',
    rating: 9.4,
    totalChapters: 165,
    status: '已完结',
    updateDate: '2025-08-30',
    views: 18920000,
    tags: ['游戏', 'VR', '冒险', '成长'],
    chapters: [
      { id: 'ch-165', title: '第165话 最终雕刻', number: 165, updateDate: '2025-08-30', views: 678000 },
      { id: 'ch-164', title: '第164话 月光之巅', number: 164, updateDate: '2025-08-23', views: 645000 },
      { id: 'ch-163', title: '第163话 众神之战', number: 163, updateDate: '2025-08-16', views: 632000 },
    ],
  },
  {
    id: 'secret-garden',
    title: '秘密花园',
    author: 'Kim Eun-sook',
    category: '恋爱',
    categorySlug: 'romance',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20of%20a%20romantic%20couple%20in%20beautiful%20flower%20garden%2C%20dreamy%20soft%20lighting%2C%20spring%20atmosphere%2C%20warm%20pastel%20coral%20tones%2C%20elegant%20character%20design%2C%20clean%20romantic%20composition&width=600&height=800&seq=manhwa-cover-11&orientation=portrait',
    description: '顶级明星与特技替身演员因一次意外灵魂互换。高冷傲慢的他，要在底层摸爬滚打；活泼泼辣的她，要在聚光灯下维持完美人设。两个生活在完全不同世界的人，因为这次离奇的遭遇而彼此靠近。当秘密花园的大门缓缓打开，一段啼笑皆非又感人至深的爱情悄然绽放。',
    rating: 9.5,
    totalChapters: 110,
    status: '已完结',
    updateDate: '2025-05-20',
    views: 17650000,
    tags: ['灵魂互换', '明星', '搞笑', '治愈'],
    chapters: [
      { id: 'ch-110', title: '第110话 我们的花园', number: 110, updateDate: '2025-05-20', views: 756000 },
      { id: 'ch-109', title: '第109话 真心告白', number: 109, updateDate: '2025-05-13', views: 732000 },
      { id: 'ch-108', title: '第108话 回到原点', number: 108, updateDate: '2025-05-06', views: 718000 },
    ],
  },
  {
    id: 'martial-arts-supreme',
    title: '武林至尊',
    author: 'Kang Chul-min',
    category: '古风',
    categorySlug: 'historical',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20of%20a%20martial%20arts%20master%20in%20traditional%20hanbok%2C%20ancient%20Korean%20setting%2C%20dramatic%20wind%20and%20bamboo%20forest%2C%20warm%20sunset%20lighting%2C%20epic%20atmosphere%2C%20clean%20composition&width=600&height=800&seq=manhwa-cover-12&orientation=portrait',
    description: '被灭门的武林世家唯一幸存者尹青云，怀揣家族秘传的绝世武功心法踏上复仇之路。从江湖最底层的乞丐到威震八方的武林至尊，他用一双铁拳打出了自己的天下。然而当他终于站在仇人面前，却发现灭门惨案背后隐藏着一个足以颠覆整个武林的惊天阴谋……',
    rating: 9.3,
    totalChapters: 134,
    status: '连载中',
    updateDate: '2026-07-31',
    views: 10230000,
    tags: ['武侠', '复仇', '热血', '古风'],
    chapters: [
      { id: 'ch-134', title: '第134话 血战光明顶', number: 134, updateDate: '2026-07-31', views: 312000 },
      { id: 'ch-133', title: '第133话 盟主之争', number: 133, updateDate: '2026-07-24', views: 305000 },
      { id: 'ch-132', title: '第132话 风云际会', number: 132, updateDate: '2026-07-17', views: 298000 },
    ],
  },
  {
    id: 'office-romance-secret',
    title: '社内恋爱禁止令',
    author: 'Park Soo-jin',
    category: '都市',
    categorySlug: 'urban',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20of%20a%20stylish%20office%20couple%20in%20modern%20business%20attire%2C%20romantic%20tension%2C%20clean%20office%20background%2C%20warm%20coral%20lighting%2C%20professional%20yet%20flirtatious%20atmosphere&width=600&height=800&seq=manhwa-cover-13&orientation=portrait',
    description: '入职第一天，姜美娜就被告知公司最大的铁则——严禁社内恋爱。然而偏偏她那位冷酷霸道的直属上司李泰俊，就是她大学时期暗恋了四年的学长！面对上司的严格要求和藏不住的悸动心情，再加上公司里其他同事若有若无的好感——这场禁忌的办公室恋情，究竟该何去何从？',
    rating: 9.0,
    totalChapters: 76,
    status: '连载中',
    updateDate: '2026-08-04',
    views: 5890000,
    tags: ['职场', '暗恋', '甜宠', '都市'],
    chapters: [
      { id: 'ch-76', title: '第76话 暴露', number: 76, updateDate: '2026-08-04', views: 168000 },
      { id: 'ch-75', title: '第75话 公司年会', number: 75, updateDate: '2026-07-28', views: 175000 },
      { id: 'ch-74', title: '第74话 加班之夜', number: 74, updateDate: '2026-07-21', views: 182000 },
      { id: 'ch-73', title: '第73话 咖啡的暗示', number: 73, updateDate: '2026-07-14', views: 178000 },
    ],
  },
  {
    id: 'dragon-king-reborn',
    title: '龙王归来',
    author: 'Choi Hyun-wook',
    category: '动作',
    categorySlug: 'action',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20of%20a%20powerful%20dragon-themed%20warrior%20with%20scales%20and%20martial%20arts%20pose%2C%20epic%20fantasy%20atmosphere%2C%20dramatic%20golden%20lighting%2C%20clean%20dynamic%20composition&width=600&height=800&seq=manhwa-cover-14&orientation=portrait',
    description: '被誉为"龙王"的地下世界霸主韩振宇，厌倦了刀光剑影的生活后选择隐退，成为一名普通的高中体育老师。然而三年的平静生活被一通神秘电话打破——他最珍视的学生被黑道绑架。愤怒的龙王再次露出獠牙，整个地下世界为之颤抖。这一次，他要用整个黑暗世界来为一个人陪葬。',
    rating: 9.2,
    totalChapters: 95,
    status: '连载中',
    updateDate: '2026-08-03',
    views: 8970000,
    tags: ['强者归来', '热血', '守护', '战斗'],
    chapters: [
      { id: 'ch-95', title: '第95话 龙啸九天', number: 95, updateDate: '2026-08-03', views: 265000 },
      { id: 'ch-94', title: '第94话 地下世界', number: 94, updateDate: '2026-07-27', views: 258000 },
      { id: 'ch-93', title: '第93话 龙之怒', number: 93, updateDate: '2026-07-20', views: 272000 },
    ],
  },
  {
    id: 'ghost-detective',
    title: '幽灵侦探',
    author: 'Jung Soo-min',
    category: '悬疑',
    categorySlug: 'suspense',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20of%20a%20detective%20in%20trench%20coat%20with%20mysterious%20atmosphere%2C%20noir%20style%2C%20rainy%20night%20city%2C%20warm%20streetlight%20glow%2C%20suspenseful%20mood%2C%20clean%20composition&width=600&height=800&seq=manhwa-cover-15&orientation=portrait',
    description: '因一场事故而获得看见鬼魂能力的刑警朴振赫，被调到了无人问津的"未结案件组"。在这里，他遇到了同样被排挤的天才女法医韩瑞妍。一个能与死者沟通，一个能从尸体中找到真相——这对奇特的搭档开始重新调查那些被遗忘的悬案。然而每一起看似独立的案件背后，都指向同一个神秘组织……',
    rating: 9.5,
    totalChapters: 68,
    status: '连载中',
    updateDate: '2026-08-02',
    views: 7230000,
    tags: ['悬疑', '灵异', '侦探', '推理'],
    chapters: [
      { id: 'ch-68', title: '第68话 最后的声音', number: 68, updateDate: '2026-08-02', views: 185000 },
      { id: 'ch-67', title: '第67话 第十三个案件', number: 67, updateDate: '2026-07-26', views: 192000 },
      { id: 'ch-66', title: '第66话 死者的信息', number: 66, updateDate: '2026-07-19', views: 188000 },
    ],
  },
];